var map = {
	"./pc1.webp": 61876,
	"./pc10.webp": 2439,
	"./pc2.webp": 26132,
	"./pc3.webp": 28864,
	"./pc4.webp": 63559,
	"./pc5.webp": 34441,
	"./pc6.webp": 77355,
	"./pc7.webp": 80285,
	"./pc8.webp": 3584,
	"./pc9.webp": 40597,
	"./phone1.webp": 1628,
	"./phone10.webp": 75345,
	"./phone2.png": 46077,
	"./phone2.webp": 10345,
	"./phone3.webp": 14440,
	"./phone4.webp": 57241,
	"./phone5.webp": 56923,
	"./phone6.webp": 61079,
	"./phone7.webp": 10190,
	"./phone8.webp": 56854,
	"./phone9.webp": 53985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69500;